module.exports = __webpack_public_path__ + "static/logo-reverse-0b8792f7b6926d0bff20325d1d3c636b.svg";